import { StudentModel } from './student.model';

export type StudentPaymentPlaceModel = StudentModel;

export enum StudentStatusActionEnum {
  rejected = 'rejected',
  approved = 'approved',
}
